import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ProductsService {
  constructor(private http: HttpClient) {}

  getProductById(id) {
    return this.http.get(`${environment.apiUrl}/products/product/${id}`).pipe();
  }

  getAllProducts(data) {
    return this.http.post(`${environment.apiUrl}/products/all`, data).pipe();
  }

  createProduct(data) {
    return this.http.post(`${environment.apiUrl}/product/create`, data).pipe();
  }

  updateProduct(id, data) {
    return this.http
      .patch(`${environment.apiUrl}/product/update/${id}`, data)
      .pipe();
  }

  deleteProduct(id) {
    return this.http
      .delete(`${environment.apiUrl}/product/delete/${id}`)
      .pipe();
  }
}
